import { z } from 'zod/v4';

export const restrictionZoneOptions = [
  'congestionZones',
  'environmentalZones',
  'ultraLowEmissionZones',
] as const;

export const restrictionZoneSchema = z.enum(restrictionZoneOptions);

export type RestrictionZone = z.infer<typeof restrictionZoneSchema>;
